/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Contains the path to a single png tat holds the images for the trashcan
 * as well as the zoom controls.
 */
export const SPRITE = {
  width: 96,
  height: 124,
  url: 'sprites.png',
};
